module.exports = __webpack_public_path__ + "static/media/JA_I1.7a27a6ca.png";